module.exports = __webpack_public_path__ + "img/train.7e429254.png";